export default "<i *ngIf=\"state\" class=\"fas\" [ngClass]=\"state\"></i>\n";